<template>
  <!-- 添付ファイル選択 -->
  <ModalDialog
    dialog-width="470px"
    dialog-height="auto"
    pop-name="添付ファイル選択"
    margin-class="mbm-3 mtp-3"
    @close="closeModal"
  >
    <template #header> </template>

    <template #body>
      <div
        v-for="(item, index) in list"
        :key="index"
        class="mtp-1 d-flex ailgn-items-center"
      >
        <div>
          <input
            :id="index"
            v-model="item.isTrue"
            type="checkbox"
            class="form-check-input"
          />
        </div>
        <label :for="index">&ensp;{{ item.name }}</label>
      </div>
    </template>

    <template #footer>
      <div class="col-12 d-flex justify-content-center">
        <ButtonMain button-name="登録" @click="create"></ButtonMain>
      </div>
    </template>
  </ModalDialog>
</template>
<script>
export default {
  name: 'AttachmentSelectionDialog',
  props: {},
  data() {
    return {
      list: [
        { isTrue: false, name: '〇〇添付資料1（マスキングあり）' },
        { isTrue: false, name: '〇〇添付資料2' }
      ]
    }
  },
  mounted() {},
  methods: {
    closeModal() {
      this.$emit('close')
    },
    create() {
      this.$emit('close')
    }
  }
}
</script>
<style scoped lang="scss"></style>
